import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import reducer from './reducers';
import saga from './sagas';

const sagaMiddleware = createSagaMiddleware()
export const history = createHistory({ basename: '/app' });

const initialState = {}

const enhancers = []
const middleware = [
  sagaMiddleware,
  routerMiddleware(history)
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  reducer,
  initialState,
  composedEnhancers
)

sagaMiddleware.run(saga)

// history.listen(location => analyticsService.track(location.pathname))

export default store



// WEBPACK FOOTER //
// ./src/store/index.js